import commonMutations from '@/store/ui/common/mutations'
import Vue from 'vue'

const mutations = {
    ...commonMutations,
    setDeletedAudienceId(state, { audienceId }) {
        Vue.set(state, 'deletedAudienceId', audienceId)
    },
    setDeletedVolumeAlertId(state, { volumeAlertId }) {
        Vue.set(state, 'deletedVolumeAlertId', volumeAlertId)
    },
    setDeletedTransfer(state, { transferId, audienceId }) {
        Vue.set(state.deletedTransfer, 'audienceId', audienceId)
        Vue.set(state.deletedTransfer, 'transferId', transferId)
    },
    setIsAudienceCcloneTargeted(state, { value }) {
        Vue.set(state, 'isAudienceCcloneTargeted', value)
    },
    setFormulaVolumes(state, { volumes, audienceId }) {
        Vue.set(state.formulaVolumes, `${audienceId}`, volumes)
    },
    setSelectedAudienceHaveDeletedCriteria(state, { result }) {
        Vue.set(state, 'selectedAudienceHaveDeletedCriteria', result)
    },
    setTypeVolume(state, { type }) {
        Vue.set(state, 'typeVolume', type)
    },
    setDeletedSharedAccount(state, { sharedAccountId, sharedAccountLabel }) {
        Vue.set(state.deletedSharedAccount, 'id', sharedAccountId)
        Vue.set(state.deletedSharedAccount, 'label', sharedAccountLabel)
    },
    setSelectedRow(state, { rowId, from }) {
        state.selectedRowId = rowId
        state.selectedRowFrom = from || null
    },
}

export default mutations
